import LibraryItem from './LibraryItem';
import React from 'react';

const LibraryItems = () => {
  return (
    <div className='flex flex-wrap max-w-full'>
      {new Array(4).fill(2).map((_, index) => (
        <LibraryItem
          key={`ph-${index}`}
          className='w-full sm:max-w-[50%] lg:max-w-[33.333%] lg:px-2 lg:max-w-[25%] pb-14 pt-0 pl-0'
        />
      ))}
    </div>
  );
};

export default LibraryItems;
